import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, LockKeyholeIcon, EyeOffIcon, UsersIcon } from 'lucide-react';
const trustSignals = [{
  icon: ShieldCheckIcon,
  title: "You're in control",
  description: 'You decide how and when to settle up, your own way.'
}, {
  icon: LockKeyholeIcon,
  title: 'Details shared on your terms',
  description: 'Optionally save your bank details, and share them only when you choose to.'
}, {
  icon: EyeOffIcon,
  title: 'Private by design',
  description: 'Only members of your kitty can view its shared expenses in the app.'
}, {
  icon: UsersIcon,
  title: 'You choose who joins',
  description: 'Admins approve join requests and manage every member.'
}];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 16
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.45,
      ease: 'easeOut'
    }
  }
};
export function TrustSecurity() {
  return <section className="py-24 lg:py-32 bg-gray-950 text-white relative overflow-hidden" data-id="element-279" data-mp="3vn3xsqfqhqp1">
      {/* Subtle glow */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-280" data-mp="4frdw3nguz5f">
        <div className="absolute bottom-0 right-1/4 w-[600px] h-[400px] bg-kitty-yellow/[0.04] rounded-full blur-3xl" data-id="element-281" data-mp="3mp1z4hjh3a4x" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-282" data-mp="3roxuxti0nv9e">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} className="text-center max-w-2xl mx-auto mb-16 lg:mb-20" data-id="element-283" data-mp="j7ju0hv34h87">
          <div className="inline-flex items-center gap-2 bg-white/[0.06] border border-white/[0.1] rounded-full px-4 py-1.5 mb-6" data-id="element-284" data-mp="eeqo3qnvr2uj">
            <ShieldCheckIcon className="w-4 h-4 text-kitty-yellow" data-id="element-285" data-mp="1241fihjcbkw0" />
            <span className="text-sm font-medium text-gray-300" data-id="element-286" data-mp="16y5nn44cdyyo">
              Security & Trust
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold leading-tight tracking-tight mb-5" data-id="element-287" data-mp="1gq8lhuibdxy6">
            You stay in control of{' '}
            <span className="text-kitty-yellow" data-id="element-288" data-mp="16tm1f7xtbax7">your money.</span>
          </h2>
          <p className="text-lg text-gray-400 max-w-xl mx-auto leading-relaxed" data-id="element-289" data-mp="11vkhylwh59l7">
            KittyPot keeps your group expenses clear and lets everyone settle up directly, person to person, your own way.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6" data-id="element-290" data-mp="t28my8erh391">
          {trustSignals.map(item => <motion.div key={item.title} variants={itemVariants} className="rounded-2xl bg-white/[0.04] border border-white/[0.08] p-6 lg:p-8 text-center flex flex-col items-center" data-id="element-291" data-mp="e5q8mebd635p">
              <div className="w-12 h-12 rounded-2xl bg-kitty-yellow/10 flex items-center justify-center mb-5" data-id="element-292" data-mp="a690te8gstxd">
                <item.icon className="w-6 h-6 text-kitty-yellow" data-id="element-293" data-mp="2ltughovey6y5" />
              </div>
              <h3 className="text-lg font-bold text-white mb-2" data-id="element-294" data-mp="2pv64jpyn2k48">
                {item.title}
              </h3>
              <p className="text-sm text-gray-500 leading-relaxed" data-id="element-295" data-mp="2uqd0ucpkwmj4">
                {item.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}